import React from 'react';
import styles from './SocialBtns.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faYoutube, faInstagram, faXTwitter, faFacebookF } from "@fortawesome/free-brands-svg-icons";

const SocialBtns = () => {
    return (
        <div className={styles.socialContainer}>
            <a 
                href="https://www.youtube.com/FasBeam" 
                target="_blank" 
                rel="noopener noreferrer" 
                className={styles.socialLink}
                aria-label="YouTube"
            >
                <FontAwesomeIcon icon={faYoutube} />
            </a>

            <a 
                href="https://www.instagram.com/fasbeam/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className={styles.socialLink}
                aria-label="Instagram"
            >
                <FontAwesomeIcon icon={faInstagram} />
            </a>

            <a 
                href="https://x.com/fasbeam" 
                target="_blank" 
                rel="noopener noreferrer" 
                className={styles.socialLink}
                aria-label="X Twitter"
            >
                <FontAwesomeIcon icon={faXTwitter} />
            </a>

            <a 
                href="https://www.facebook.com/FasBeam/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className={styles.socialLink}
                aria-label="Facebook"
            >
                <FontAwesomeIcon icon={faFacebookF} />
            </a>
        </div>
    );
};

export default SocialBtns;